import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { format, parseISO } from 'date-fns';

import Loading from '../../common/Loading';
import Error from '../../common/Error';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function LoadListListItemProjectDetails(props){
    //console.debug("RTS Break LoadListListItemProjectDetails");

    const {userAuthToken, apiRoot, userLogOut} = useSessionContext();
        
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    
    const [data, setData] = useState([]);
    

    const fetchData = useCallback((pFilter) => {
        setIsLoading(true);
        let apiURL = apiRoot + "/Projects/GetProjectById/" + pFilter;
        axios
        .get(
            apiURL,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setIsLoading(false);
                setData(response.data);
            }
        })
        .catch(error => {
            setIsLoading(false);

            if(error.status === 401){
                userLogOut();
            }
            else{
                setHasError(true);
                console.log("RTS Data Error", error);
            }
        });
    },[apiRoot, userAuthToken.token, userLogOut]); 


    useEffect(() => {
            fetchData(props.idGuid);
    }, [props, fetchData]); 



    function showManagerName(){
        if(data==null){
            return "";
        }
        else{
            if(data.manager==null){
                return "";
            }
            else{
                return data.manager.firstName + " " + data.manager.lastName;
            }
        }
    }


    if(hasError){
        return(
            <Error />
        );
    };


    if(isLoading){
        return(
            <Loading />
        );
    };

    
    return (
        <Box>        
            <Box sx={{display:'flex'}}>
                <Typography variant="body2" sx={{fontWeight:'bold'}}>Project Name:</Typography>
                <Typography variant="body2" sx={{ml:'2px'}}>{data==null?"No Project":data.name}</Typography>
            </Box>
            <Box sx={{display:'flex'}}>
                <Typography variant="body2" sx={{fontWeight:'bold'}}>Description:</Typography>
                <Typography variant="body2" sx={{ml:'2px'}}>{data==null?"":data.desc}</Typography>
            </Box>
            <Box sx={{display:'flex'}}>
                <Typography variant="body2" sx={{fontWeight:'bold'}}>Manager:</Typography>
                <Typography variant="body2" sx={{ml:'2px'}}>{showManagerName()}</Typography>
            </Box>
            <Box sx={{display:'flex'}}>
                <Typography variant="body2" sx={{fontWeight:'bold'}}>External Id:</Typography>
                <Typography variant="body2" sx={{ml:'2px'}}>{data==null?"":data.idExt}</Typography>
            </Box>
            <Grid container>
                <Grid item xs={12} sm={6}>
                    <Box sx={{display:'flex', whiteSpace:'nowrap'}}>
                        <Typography variant="body2" sx={{fontWeight:'bold'}}>Start Date:</Typography>
                        {data.startDate != null
                        ?
                        <Typography variant="body2" sx={{ml:'2px'}}>{data==null?"":format(parseISO(data.startDate), "MM-dd-yyyy")}</Typography>
                        :
                        ""
                        }
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Box sx={{display:'flex', whiteSpace:'nowrap'}}>
                        <Typography variant="body2" sx={{fontWeight:'bold'}}>End Date:</Typography>
                        {data.endDate != null
                        ?
                        <Typography variant="body2" sx={{ml:'2px'}}>{data==null?"":format(parseISO(data.endDate), "MM-dd-yyyy")}</Typography>
                        :
                        ""
                        }
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}

